function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Medical Cross Icon");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Homepage",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-Homepage",
  transform: "translate(-257.000000, -1317.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-10",
  transform: "translate(258.000000, 1318.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-8"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-364",
  fill: "currentcolor",
  points: "34.5 17.7555582 26.7437285 17.7555582 26.7437285 10 18.2555582 10 18.2555582 17.7555582 10.5 17.7555582 10.5 26.2437285 18.2555582 26.2437285 18.2555582 34 26.7437285 34 26.7437285 26.2437285 34.5 26.2437285"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.5,22 C0.5,34.1505575 10.3497104,44 22.4994017,44 C34.6502896,44 44.5,34.1505575 44.5,22 C44.5,9.85063911 34.6502896,0 22.4994017,0 C10.3497104,0 0.5,9.85063911 0.5,22 Z",
  id: "Stroke-366",
  stroke: "currentcolor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))));

var SvgMedicalCrossCircle = function SvgMedicalCrossCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 47 46",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMedicalCrossCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medical-cross-circle.a2f0c2f6.svg";
export { ForwardRef as ReactComponent };